import React, { useState } from 'react';
import '../App.css';
import {
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Button,
  Box,
  Heading,
  Flex,
  Text,
} from '@chakra-ui/react';
import { ResultHeptathlonTable } from './components/ResultHeptathlonTable';
import { heptathlonEventListType, heptathlonEventType } from '../common/types';

import { createHeptathlonForecastData } from './functions/createHeptathlonScoreData';
import { ResultHeptathlonEventTable } from './components/ResultHeptathlonEventTable';
import { Link } from 'react-router-dom';
import { ExternalLinkIcon, RepeatIcon } from '@chakra-ui/icons';
import {
  useHepCPBData,
  useHepCSBData,
  useHepPBData,
  useHepResultData,
  useHepSBData,
} from './request/requests';
import { handleUpdate, ResultLink } from './components/ResultLink';
import { dateGame, titleGame } from './components/TitleGame';
import { ResultHeptathlonTableEn } from './components/ResultHeptathlonTableEn';
import { ResultHeptathlonEventTableEn } from './components/ResultHeptathlonEventTableEn';

export const HeptathlonResultTableEn = () => {
  const EventList: heptathlonEventListType = {
    i00h: '100mH',
    hj: 'HighJump',
    sp: 'ShotPut',
    z00: '200m',
    lj: 'LongJump',
    jt: 'JavelinThrow',
    B00: '800m',
  };

  //  papa.parseでスプレッドシートから記録を取得する
  const data = useHepResultData();
  const csbDataInitial = useHepCSBData();
  const cpbDataInitial = useHepCPBData();
  const sbData = useHepSBData();
  const pbData = useHepPBData();

  //  現在終了種目時点での予想記録を作成する
  const sbForecastData = data.map((d, i) =>
    createHeptathlonForecastData(
      d,
      !!csbDataInitial[i] ? csbDataInitial[i] : csbDataInitial[0]
    )
  );
  const pbForecastData = data.map((d, i) =>
    createHeptathlonForecastData(
      d,
      !!cpbDataInitial[i] ? cpbDataInitial[i] : cpbDataInitial[0]
    )
  );

  // タブスライダーの実装
  // const [tabIndex, setTabIndex] = useState(0);
  // const handleSliderChange = (event: any) => {
  //   setTabIndex(parseInt(event.target.value, 10));
  // };
  // const handleTabsChange = (index: number) => {
  //   setTabIndex(index);
  // };

  return (
    <>
      {/* <Box m={'8px'}>
        <Heading as="h4" size="md">
          {dateGame}
          <br />
          {titleGame}
        </Heading>
        <ResultLink />
      </Box> */}
      　World Athletics Championships Tokyo 25 <br />　
      <br />　
      <Button size="md" fontWeight="light" variant="link">
        <Link to={'/dec/en'}>Decathlon Result</Link>
        <ExternalLinkIcon />
      </Button>
      <br />　
      <Button size="md" fontWeight="light" variant="link">
        <Link to={'/hep/en'}> Heptathlon Result</Link>
        <ExternalLinkIcon />
      </Button>
      <br />
      <Flex justify="space-between" mr={4}>
        <Text fontSize={'xs'}>
          <br />　 Click on the player's name to see their records. <br />　
        </Text>
        <Button colorScheme="gray" onClick={handleUpdate} size="xs">
          Reload
          <RepeatIcon />
        </Button>
      </Flex>{' '}
      　Swipe tabs to view more events
      <Tabs
        size="sm"
        variant="soft-rounded"
        colorScheme="green"
        // index={tabIndex}
        // onChange={handleTabsChange}
      >
        <TabList overflowX="auto" whiteSpace="nowrap">
          <Tab>RESULT</Tab>

          <Tab>
            Pred. Rank
            <br />
            (SB)
          </Tab>
          <Tab>
            Pred. Rank
            <br />
            (PB)
          </Tab>
          {Object.values(EventList).map((event, i) => {
            return <Tab key={i}>{event}</Tab>;
          })}
          <Tab>SB Rank</Tab>
          <Tab>PB Rank</Tab>
          <Tab>Potential SB</Tab>
          <Tab>Potential PB</Tab>
        </TabList>

        <TabPanels>
          <TabPanel>
            <ResultHeptathlonTableEn
              Data={data}
              rawData={data}
              title="Result"
              csbData={csbDataInitial}
              cpbData={cpbDataInitial}
              sbData={sbData}
              pbData={pbData}
            />
          </TabPanel>

          <TabPanel>
            <ResultHeptathlonTableEn
              Data={sbForecastData}
              rawData={data}
              title="Pred. Rank(SB)"
              csbData={csbDataInitial}
              cpbData={cpbDataInitial}
              sbData={sbData}
              pbData={pbData}
            />
          </TabPanel>
          <TabPanel>
            <ResultHeptathlonTableEn
              Data={pbForecastData}
              rawData={data}
              title="Pred. Rank(PB)"
              csbData={csbDataInitial}
              cpbData={cpbDataInitial}
              sbData={sbData}
              pbData={pbData}
            />
          </TabPanel>
          {Object.keys(EventList).map((event, i) => {
            const e = event as heptathlonEventType;
            return (
              <TabPanel key={i}>
                <ResultHeptathlonEventTableEn
                  Event={e}
                  Data={data}
                  csbData={csbDataInitial}
                  cpbData={cpbDataInitial}
                  sbData={sbData}
                  pbData={pbData}
                />
              </TabPanel>
            );
          })}
          <TabPanel>
            <ResultHeptathlonTableEn
              Data={csbDataInitial}
              rawData={data}
              title="SB Rank"
              csbData={csbDataInitial}
              cpbData={cpbDataInitial}
              sbData={sbData}
              pbData={pbData}
            />
          </TabPanel>
          <TabPanel>
            <ResultHeptathlonTableEn
              Data={cpbDataInitial}
              rawData={data}
              title="PB Rank"
              csbData={csbDataInitial}
              cpbData={cpbDataInitial}
              sbData={sbData}
              pbData={pbData}
            />
          </TabPanel>
          <TabPanel>
            <ResultHeptathlonTableEn
              Data={sbData}
              rawData={data}
              title="Potential SB"
              csbData={csbDataInitial}
              cpbData={cpbDataInitial}
              sbData={sbData}
              pbData={pbData}
            />
          </TabPanel>
          <TabPanel>
            <ResultHeptathlonTableEn
              Data={pbData}
              rawData={data}
              title="Potential PB"
              csbData={csbDataInitial}
              cpbData={cpbDataInitial}
              sbData={sbData}
              pbData={pbData}
            />
          </TabPanel>
        </TabPanels>
      </Tabs>
      {/* <Input
        type="range"
        min="0"
        max="14"
        value={tabIndex}
        onChange={handleSliderChange}
        position="fixed"
        bottom="0"
        zIndex="30"
        backgroundColor="white"
      /> */}
    </>
  );
};
